// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"21af418b","71":"0002e1ae","220":"7d6c329f","345":"12c14119","351":"0c5e1e99","448":"25fc9cf7","450":"3d26c59e","453":"5cffa308","607":"0b078911","610":"f5a42496","719":"269de76b"}[chunkId] + ".chunk.js";
};